import { topSidePartOfWeb } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const w38Web = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'

  // ウェブ本体
  const drawMainPath = () => {
    ctx.beginPath()
    ctx.moveTo(300, 376) // 左下
    ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
    ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
    ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
    ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawMainPath, webColor)

  // stitchここから
  ctx.lineWidth = 1.3
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])

  // デザインステッチ_人差し指寄り
  ctx.moveTo(333, 124) // 左上
  ctx.quadraticCurveTo(345, 140, 345, 186)
  ctx.quadraticCurveTo(285, 171, 285, 171)
  ctx.moveTo(316, 140) // 左上
  ctx.quadraticCurveTo(322, 155, 322, 155)
  ctx.quadraticCurveTo(303, 152, 303, 152)

  ctx.moveTo(272, 186)
  ctx.quadraticCurveTo(366, 237, 366, 237)
  ctx.quadraticCurveTo(253, 294, 253, 294)
  ctx.moveTo(259, 208)
  ctx.quadraticCurveTo(320, 232, 320, 232)
  ctx.quadraticCurveTo(241, 277, 241, 277)

  ctx.moveTo(265, 315)
  ctx.quadraticCurveTo(350, 289, 350, 289)
  ctx.quadraticCurveTo(293, 358, 293, 358)

  ctx.moveTo(278, 335)
  ctx.quadraticCurveTo(310, 319, 310, 319)
  ctx.quadraticCurveTo(286, 348, 286, 348)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  ctx.lineWidth = 1.0

  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
}
